import Skeleton from '@polestar/component-warehouse-react/components/skeleton/Skeleton';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import styled from '@emotion/styled';
import React, { forwardRef, memo } from 'react';
const VideoPlayerSkeleton = memo(forwardRef(({ children, ...props }, ref) => {
    return (React.createElement(Wrapper, { ref: ref, ...props },
        React.createElement(CustomSkeleton, { ...props }),
        React.createElement(Center, null, children)));
}));
VideoPlayerSkeleton.displayName = 'VideoPlayerSkeleton';
export default VideoPlayerSkeleton;
const Wrapper = styled.div `
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
`;
const Center = styled.div `
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
`;
const CustomSkeleton = styled(Skeleton, shouldNotForwardProps(false, 'width', 'height')) ``;
